import {helpers} from '@/ft-vue-core'
const {deepClone, getMemberPhoto} = helpers
export default {
  data () {
    return {
      occasionsMap: {}
    }
  },
  mounted () {
    this.$ftAPI().get(this.addResourceErrorHandler({
      command: 'diningOccasion',
      load: resp => {
        this.occasionsMap = resp?.reduce((acc, r) => {
          acc[r.id] = r
          return acc
        }, {}) ?? {}
      }
    }))
  },
  methods: {
    getExpandMemberList (item) {
      const result = []
      // First put reservation cards
      if (item.occasionId) {
        result.push({
          icon: 'mdi-gift',
          name: (this.occasionsMap[item.occasionId] || {}).name,
          member: {diningSpecialRequests: item.memberSpecialRequests}
        })
      } else if (item.memberSpecialRequests) {
        result.push({
          icon: 'mdi-message-text',
          name: 'Special Requests',
          member: {diningSpecialRequests: item.memberSpecialRequests}
        })
      }
      if (item.specialRequests) {
        result.push({
          icon: 'mdi-message-outline',
          name: 'Hidden Requests',
          member: {diningSpecialRequests: item.specialRequests}
        })
      }
      // Now generate member cards
      var lastMemberDetail = null
      const memberCards = item.details.reduce((acc, detail) => {
        if (!item.cancelled && detail.cancelled) return acc
        if (detail.member || !lastMemberDetail) {
          lastMemberDetail = deepClone(detail)
          const member = lastMemberDetail.member || {}
          lastMemberDetail.member = member
          acc.push(lastMemberDetail)
          lastMemberDetail.memberPhoto = getMemberPhoto(member.activePhoto, member.gender)
          if (detail.guestTypeId) {
            const guestType = 'Unaccompanied ' + ((this.guestTypeMap[detail.guestTypeId] || {}).name || '')
            if (detail.name) {
              member.memNum = guestType
            } else {
              detail.name = guestType
            }
          }
          lastMemberDetail.guests = []
        } else {
          // Must be guest of last member
          lastMemberDetail.guests.push(detail)
        }
        return acc
      }, [])
      result.push(...memberCards)
      return result
    },
    getExpandedGuests (detail) {
      var lastGuest = null
      var diffCount = 0
      if (!detail.guests) return null
      const result = detail.guests.reduce((acc, guest) => {
        if (guest.guestTypeId === null) return acc
        if (lastGuest == null || guest.name !== lastGuest.name || guest.guestTypeId !== lastGuest.guestTypeId) {
          lastGuest = deepClone(guest)
          lastGuest.count = 1
          lastGuest.typeName = (this.guestTypeMap[lastGuest.guestTypeId] || {}).name || ''
          if (lastGuest != null && lastGuest.name) diffCount++
          acc.push(lastGuest)
        } else {
          // same guest type/name
          lastGuest.count++
        }
        return acc
      }, [])
      return diffCount ? result : null
    },
  }
}